import React from 'react';
import PropTypes from 'prop-types';

const LoadingFallback = ({ message, fullScreen }) => {
  return (
    <div 
      className="loading-fallback" 
      style={fullScreen ? { 
        height: '100vh',
        width: '100%'
      } : {}}
    >
       <div className="flex justify-center py-12">
          <div className="animate-spin h-10 w-10 border-t-2 border-b-2 border-orange-500 rounded-full"></div>
        </div>
    </div>
  );
};

LoadingFallback.propTypes = {
  message: PropTypes.string,
  fullScreen: PropTypes.bool
};

LoadingFallback.defaultProps = {
  fullScreen: true
};

export default LoadingFallback;
